import * as React from 'react';
import * as S from './styles';
import { ReactComponent as EditIcon } from 'common/images/icon-edit.svg';
import { ReactComponent as ExIcon } from 'common/images/close-icon.svg';
import { ReactComponent as ExIconGray } from 'common/images/close-icon-gray.svg';
import { validateHourFormat, validateOnlyNumbers } from 'features/Dealers/Listings/Data/state/utils';
import { KeywordFormat } from 'features/Dealers/Listings/Keywords';
import * as _ from 'lodash';

export interface EditKeywordsProps {
  keywordsState?: KeywordFormat[];
  setKeywordsState: Function;
}

const EditKeywords: React.FC<EditKeywordsProps> = (props) => {

  const [newLocationString, setNewLocatrionString] = React.useState<string>("");
  const [editLocationString, setEditLocationString] = React.useState<string>("");
  const [newKeywordString, setNewKeywordString] = React.useState<string>("");
  const [editKeywordString, setEditKeywordString] = React.useState<string>("");

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>, field: string, index?: number) => {
    if (index !== undefined) {
      if (field === "keywords") {
        setEditKeywordString(e.target.value);
      } else {
        setEditLocationString(e.target.value);
      }
    } else {
      if (field === "keywords") {
        setNewKeywordString(e.target.value);
      } else {
        setNewLocatrionString(e.target.value);
      }
    }
  }

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>, field: string, index?: number) => {
    if (field === "keywords" && e.key === "Enter") {
      e.preventDefault();
      if (index !== undefined) {
        saveEditKeyword(index);
      } else {
        addKeyword();
      }
    }
  }

  const addKeyword = () => {
    const keywordChecked = newKeywordString.trim();
    const locationNameChecked = newLocationString.trim();
    if (keywordChecked !== "" && locationNameChecked !== "" && props.keywordsState && props.keywordsState.length < 50) {
      const addKeyword = {keywords: [keywordChecked], locationName: locationNameChecked};
      if (props.keywordsState?.length > 0) {
        props.setKeywordsState([
          ...props.keywordsState,
          addKeyword
        ]);
      } else {
        props.setKeywordsState([addKeyword]);
      }
      setNewLocatrionString("");
      setNewKeywordString("");
    }
  }

  const editKeyword = (index: number) => {
    if (props.keywordsState?.length) {
      const keywordData = _.cloneDeep(props.keywordsState[index]);
      if (props.keywordsState?.length) {
        props.setKeywordsState([
          ...props.keywordsState.slice(0, index),
          {...keywordData, editing: true},
          ...props.keywordsState.slice(index + 1)
        ]);
        setEditLocationString(keywordData.locationName);
        setEditKeywordString(keywordData.keywords[0]);
      }
    }
  }

  const saveEditKeyword = (index: number) => {
    const keywordChecked = editKeywordString.trim();
    const locationNameChecked = editLocationString.trim();
    if (props.keywordsState?.length && keywordChecked !== "" && locationNameChecked !== "") {
      const editKeyword = {keywords: [keywordChecked], locationName: locationNameChecked};
      props.setKeywordsState([
        ...props.keywordsState.slice(0, index),
        {...editKeyword, editing: false},
        ...props.keywordsState.slice(index + 1)
      ]);
      setEditLocationString("");
      setEditKeywordString("");
    }
  }

  const removeKeyword = (index: number) => {
    if (props.keywordsState?.length) {
      props.setKeywordsState([
        ...props.keywordsState.slice(0, index),
        ...props.keywordsState.slice(index + 1)
      ]);
    }
  }

  const renderInputField = (field: string, value: string, placeholder?: string,  index?: number) => {
    return (
      <S.EditKInput
        maxWidthValue={field === "keywords" ? "210px" : "150px"}
        id={`${field}-${index}`}
        value={value.toString()}
        placeholder={placeholder}
        onChange={(e) => onInputChange(e, field, index)}
        onKeyPress={(e) => handleKeyPress(e, field, index)}
      />
    )
  }

  const renderKeywordRow = (keywordData?: KeywordFormat, index?: number) => {
    return (
      <S.EditKRowBigContainer key={index} >
        <S.EditKRowContainer>
          <S.EditKRowKeywords>
            { (index === undefined || keywordData?.editing) ?
                <S.EditKDateFields>
                  {renderInputField("keywords", index === undefined ? newKeywordString : editKeywordString, "Keyword", index)}
                </S.EditKDateFields>
              :
                <S.ViewKeywordLabelEdit>
                  {keywordData?.keywords[0] ?? ""}
                </S.ViewKeywordLabelEdit>
            }
          </S.EditKRowKeywords>
          <S.EditKRowLocationsName>
            <S.EditKRowLocationsNameDetail>
              { (index === undefined || keywordData?.editing) ?
                  <S.EditKHoursFields>
                    {renderInputField("locationName", index === undefined ? newLocationString : editLocationString, "City and State", index)}
                  </S.EditKHoursFields>
                :
                  <S.ViewKeywordLabelEdit>
                    {keywordData?.locationName}
                  </S.ViewKeywordLabelEdit>
              }
              <S.EditKActionsContainer>
                {
                  index === undefined ? 
                    <S.EditKActionAdd
                      onClick={addKeyword}
                    >
                      Add
                    </S.EditKActionAdd>
                  :
                    <>
                      { keywordData?.editing ? 
                          <S.EditKActionAdd
                            onClick={() => saveEditKeyword(index)}
                          >
                            Save
                          </S.EditKActionAdd>
                        :
                          <>
                            <S.EditKActionEdit
                              onClick={() => editKeyword(index)}
                            >
                              <EditIcon />
                            </S.EditKActionEdit>
                            <S.EditKActionClose
                              onClick={() => removeKeyword(index)}
                            >
                              <ExIcon />
                            </S.EditKActionClose>
                          </>
                      }
                    </>
                }
              </S.EditKActionsContainer>
            </S.EditKRowLocationsNameDetail>
          </S.EditKRowLocationsName>
        </S.EditKRowContainer>
        { (index !== undefined && props.keywordsState && index < props.keywordsState.length - 1) &&
          <S.EditKDividerContainer>
            <S.EditKDivider />
          </S.EditKDividerContainer>
        }
      </S.EditKRowBigContainer>
    );
  }

  return (
    <S.EditKeywordsContainer>
      <S.MaximumKeywordsLabel>
        Add up to 50 keywords per location. Hit enter to add.
      </S.MaximumKeywordsLabel>
      { renderKeywordRow() }
      <S.EditSHRowsContainer>
        { (props.keywordsState && props.keywordsState.length > 0) &&
          <S.EditKRowTitleContainer>
            <S.EditKRowKeywords>
              <S.EditKRowTitle>
                Keywords
              </S.EditKRowTitle>
            </S.EditKRowKeywords>
            <S.EditKRowLocationsName>
              <S.EditKRowTitle>
                Location
              </S.EditKRowTitle>
            </S.EditKRowLocationsName>
          </S.EditKRowTitleContainer>
        }
        { (props.keywordsState && props.keywordsState.length > 0) ?
            props.keywordsState.map((keyword, index) => {
              return renderKeywordRow(keyword, index);
            })
          :
            <S.EditSHEmptyState>
              Add keywords to view them here
            </S.EditSHEmptyState>
        }
      </S.EditSHRowsContainer>
    </S.EditKeywordsContainer>
  )
}

export default EditKeywords